import React, { useState, useEffect } from "react";

const Permissions = ({ data, value, onChange }) => {
  const [selected, setSelected] = useState(value || []); // array of IDs

  // 🔹 Sync state when value prop changes
  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  console.log("selected ids", selected);

  // Helper
  const isSelected = (id) => selected.includes(id);

  // Update state + notify parent
  const updateSelected = (newSelected) => {
    setSelected(newSelected);
    if (onChange) onChange(newSelected);
  };

  // Toggle parent (only itself, clear children if unchecked)
  const toggleParent = (parent) => {
    if (isSelected(parent.id)) {
      // remove parent + its children
      const childIds = (parent.children || []).map((c) => c.id);
      updateSelected(
        selected.filter((id) => id !== parent.id && !childIds.includes(id))
      );
    } else {
      // add only parent
      updateSelected([...selected, parent.id]);
    }
  };

  // Toggle child
  const toggleChild = (parentId, childId) => {
    if (!isSelected(parentId)) return; // parent must be selected
    if (isSelected(childId)) {
      updateSelected(selected.filter((id) => id !== childId));
    } else {
      updateSelected([...selected, childId]);
    }
  };

  return (
    <div className="py-6">
      <h2 className="text-lg font-semibold mb-4 text-gray-800">
        Assign Permissions
      </h2>

      <div className="space-y-4">
        {data.map((perm) => (
          <div
            key={perm.id}
            className="border border-gray-200 rounded-xl p-4 bg-gray-50"
          >
            {/* Parent */}
            <label className="flex items-center gap-2 font-medium text-[#142b70]/80 cursor-pointer">
              <input
                type="checkbox"
                className="h-4 w-4 accent-[#a48572] cursor-pointer"
                checked={isSelected(perm.id)}
                onChange={() => toggleParent(perm)}
              />
              {perm.description}
            </label>

            {/* Children */}
            <div className="ml-7 mt-2 grid grid-cols-2 gap-2">
              {perm.children?.map((child) => (
                <label
                  key={child.id}
                  className={`flex items-center gap-2 font-medium text-[#142b70]/80 cursor-pointer ${
                    !isSelected(perm.id) ? "opacity-50" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    className="h-4 w-4 accent-[#a48572] cursor-pointer"
                    checked={isSelected(child.id)}
                    disabled={!isSelected(perm.id)}
                    onChange={() => toggleChild(perm.id, child.id)}
                  />
                  {child.description}
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Permissions;
